import React, { useState } from 'react'

const ImageWithFallback = ({ projectInfo,src }) => {
  // const src =" https://gizmeon.s.llnwi.net/vod/config/1686310878463.pn"
    const fallbackSrc = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
    const [imgSrc, setImgSrc] = useState(fallbackSrc);

    const handleImageLoadError = () => {
      setImgSrc(fallbackSrc);
    };
  
    return <img src={imgSrc} onLoad={() => setImgSrc(src)} onError={handleImageLoadError} alt="Img" />;
}

export default ImageWithFallback